module.exports = __webpack_public_path__ + "static/media/kudos-heart.f110f6df.gif";